import zwitCore from "./config/http";
// const BASE_URL = "/apis";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";

export default {
  getYearList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/year/infoPage");
  },
  getSubjectList() {
    return zwitCore.HTTP.get(BASE_URL + "/zw-public/researchField/getAllList");
  },
};
